import { cn } from "design/lib/utils"
import { HugeiconsIcon } from "@hugeicons/react"
import { Loading03Icon } from "@hugeicons/core-free-icons"
import type { ComponentProps } from "react"

type Props = Omit<ComponentProps<typeof HugeiconsIcon>, "icon">

function Spinner({ className, ...props }: Props) {
  return (
    <HugeiconsIcon
      icon={Loading03Icon}
      strokeWidth={2}
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
